import { QueryClient } from '@tanstack/react-query';
import { HTTPError } from 'ky';

const MINUTE_MS = 60_000;
const MAX_RETRIES = 1;
// Client errors won't heal on retry — fail immediately
const NO_RETRY_STATUSES = [400, 401, 403, 404, 422];

// Module singleton so non-React code (auth events, WS handlers) can touch the cache.
export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: { retry: false },
    queries: {
      gcTime: 10 * MINUTE_MS,
      staleTime: 5 * MINUTE_MS,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => failureCount < MAX_RETRIES && !(error instanceof HTTPError && NO_RETRY_STATUSES.includes(error.response.status)),
    },
  },
});
